import React, { ComponentType } from 'react';
import {
  LoyaltySmall,
  TaxSmall,
  ShippingSmall,
  SiteSearchSmall,
} from '@wix/wix-ui-icons-common';
import { useIsMobile } from 'hooks/useIsMobile';
import type { ExistingSiteStoreReadyBoxId } from '../existingSiteStoreReadyUiStore';
import styles from '../ExistingSiteStoreReadyStep.scss';

const PANEL_ICONS: Record<ExistingSiteStoreReadyBoxId, ComponentType> = {
  'page-ready': LoyaltySmall,
  margin: TaxSmall,
  delivery: ShippingSmall,
  'add-more-products': SiteSearchSmall,
};

interface PanelIconPlaceholderProps {
  boxId: ExistingSiteStoreReadyBoxId;
}

export function PanelIconPlaceholder({ boxId }: PanelIconPlaceholderProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  const Icon = PANEL_ICONS[boxId];

  return (
    <div className={styles.existingSiteStoreReadyPanelIllustration} aria-hidden>
      <Icon />
    </div>
  );
}
